import { ca } from '@cian/analytics';

import { TOpenedChat } from '../../types/openedChats';
import { getProducts } from '../../utils/trackings_helpers';

export function trackCloseNoLinksPopup(chat: TOpenedChat | null, opponentId?: number) {
  const products = chat && chat.offer ? getProducts([chat.offer]) : [];

  ca('eventSite', {
    action: 'Close_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    products,
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
export function trackCloseForbiddenTextPopup(chat: TOpenedChat | null, opponentId?: number) {
  const products = chat && chat.offer ? getProducts([chat.offer]) : [];

  ca('eventSite', {
    action: 'Close_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    products,
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackClickForbiddenTextPopupLink(chat: TOpenedChat | null, opponentId?: number) {
  const products = chat && chat.offer ? getProducts([chat.offer]) : [];

  ca('eventSite', {
    action: 'Details_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    products,
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackClickForbiddenTextPopupButton(chat: TOpenedChat | null, opponentId?: number) {
  const products = chat && chat.offer ? getProducts([chat.offer]) : [];

  ca('eventSite', {
    action: 'Ok_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    products,
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackResendErrorMessageClick(chat: TOpenedChat | null, opponentId?: number) {
  const products = chat && chat.offer ? getProducts([chat.offer]) : [];

  ca('eventSite', {
    action: 'Correct_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
    products,
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackRemoveFromSpamClick(restoreType: 'spam' | 'archive', opponentId?: number) {
  ca('eventSite', {
    action: `mark_message_as_${restoreType}_cancel`,
    category: 'Chat',
    name: 'oldevent',
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

const CHAT_LINK_ERROR_PARAMS = {
  name: 'oldevent',
  category: 'Chat',
  label: 'error_screen',
};

export function trackChatLinkErrorModalShow(errorText: string) {
  ca('eventSite', {
    ...CHAT_LINK_ERROR_PARAMS,
    action: 'error_screen_show',
    page: {
      extra: {
        errormessage: errorText,
      },
    },
  });
}

export function trackChatLinkErrorModalClose(errorText: string) {
  ca('eventSite', {
    ...CHAT_LINK_ERROR_PARAMS,
    action: 'click_close_button',
    page: {
      extra: {
        errormessage: errorText,
      },
    },
  });
}
